// extracted by mini-css-extract-plugin
module.exports = {"ourPeopleSection":"cK_jN","videoSection":"cK_jP"};